// Major global Muslim-majority / travel cities for prayer-time context.
export interface IntlCity {
  key: string;
  en: string;
  bn: string;
  country: string;
  lat: number;
  lon: number;
}

export const INTERNATIONAL_CITIES: IntlCity[] = [
  { key: "mecca",       en: "Mecca",        bn: "মক্কা",       country: "Saudi Arabia",  lat: 21.4225, lon: 39.8262 },
  { key: "medina",      en: "Medina",       bn: "মদিনা",       country: "Saudi Arabia",  lat: 24.5247, lon: 39.5692 },
  { key: "jeddah",      en: "Jeddah",       bn: "জেদ্দা",      country: "Saudi Arabia",  lat: 21.4858, lon: 39.1925 },
  { key: "riyadh",      en: "Riyadh",       bn: "রিয়াদ",      country: "Saudi Arabia",  lat: 24.7136, lon: 46.6753 },
  { key: "dubai",       en: "Dubai",        bn: "দুবাই",       country: "UAE",            lat: 25.2048, lon: 55.2708 },
  { key: "doha",        en: "Doha",         bn: "দোহা",        country: "Qatar",          lat: 25.2854, lon: 51.5310 },
  { key: "kuwait",      en: "Kuwait City",  bn: "কুয়েত",      country: "Kuwait",         lat: 29.3759, lon: 47.9774 },
  { key: "muscat",      en: "Muscat",       bn: "মাস্কাট",     country: "Oman",           lat: 23.5880, lon: 58.3829 },
  { key: "istanbul",    en: "Istanbul",     bn: "ইস্তাম্বুল",  country: "Turkey",         lat: 41.0082, lon: 28.9784 },
  { key: "cairo",       en: "Cairo",        bn: "কায়রো",      country: "Egypt",          lat: 30.0444, lon: 31.2357 },
  { key: "kualalumpur", en: "Kuala Lumpur", bn: "কুয়ালালামপুর", country: "Malaysia",     lat: 3.1390,  lon: 101.6869 },
  { key: "jakarta",     en: "Jakarta",      bn: "জাকার্তা",    country: "Indonesia",      lat: -6.2088, lon: 106.8456 },
  { key: "singapore",   en: "Singapore",    bn: "সিঙ্গাপুর",   country: "Singapore",      lat: 1.3521,  lon: 103.8198 },
  { key: "london",      en: "London",       bn: "লন্ডন",       country: "UK",             lat: 51.5074, lon: -0.1278 },
  { key: "newyork",     en: "New York",     bn: "নিউ ইয়র্ক",  country: "USA",            lat: 40.7128, lon: -74.0060 },
  { key: "toronto",     en: "Toronto",      bn: "টরন্টো",      country: "Canada",         lat: 43.6532, lon: -79.3832 },
  { key: "sydney",      en: "Sydney",       bn: "সিডনি",       country: "Australia",      lat: -33.8688, lon: 151.2093 },
  { key: "karachi",     en: "Karachi",      bn: "করাচী",       country: "Pakistan",       lat: 24.8607, lon: 67.0011 },
  { key: "lahore",      en: "Lahore",       bn: "লাহোর",       country: "Pakistan",       lat: 31.5204, lon: 74.3587 },
  { key: "delhi",       en: "Delhi",        bn: "দিল্লি",      country: "India",          lat: 28.6139, lon: 77.2090 },
  { key: "kolkata",     en: "Kolkata",      bn: "কলকাতা",      country: "India",          lat: 22.5726, lon: 88.3639 },
];
